import React from 'react';
import { Divider, Typography, Box } from '@mui/material';


interface ChatSeparatorProps {
	text: string;
}
const ChatSeparator = ({ text }: ChatSeparatorProps) => {
	return (
		<Box display="flex" alignItems="center" my={2}>
			<Divider sx={{ flexGrow: 1 }} />
			<Typography variant="body2" sx={{ mx: 2, color: 'gray', textAlign: 'center' }}>
				{text}
			</Typography>
			<Divider sx={{ flexGrow: 1 }} />
		</Box>
	);
};

export default ChatSeparator;
